/* ===== DENTICOL (dnt) interactions ===== */
(function(){
  if(window.__dntInit) return; window.__dntInit=true;

  /* --- Scroll CTAs to the product buy-box / quantity selector --- */
  function buyTarget(){
    return document.querySelector('.dnt-sb') ||
           document.getElementById('dnt-buy') ||
           document.querySelector('.quantity-break') ||
           document.querySelector('[class*="quantity-breaks"]') ||
           document.querySelector('.product-form__buttons') ||
           document.querySelector('.product-form') ||
           document.querySelector('[id^="MainProduct-"]') ||
           document.getElementById('dnt-buy');
  }
  function headerOffset(){
    var h=document.querySelector('.section-header, header[role="banner"], .header-wrapper, sticky-header');
    var hh=h?h.getBoundingClientRect().height:0;
    if(!hh||hh>200) hh=80; // sticky header can report huge height
    return hh+12;
  }
  function scrollToBuy(){
    var t=buyTarget(); if(!t) return;
    var y=t.getBoundingClientRect().top+window.pageYOffset-headerOffset();
    window.scrollTo({top:y,behavior:'smooth'});
    var pick=document.querySelector('.quantity-break input, input[name="quantity"]');
    if(pick){ try{ pick.focus({preventScroll:true}); }catch(e){} }
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-dnt-scroll]');
    if(b){ e.preventDefault(); scrollToBuy(); }
  });

  /* --- Carousels --- */
  function initCaro(caro){
    var track=caro.querySelector('.dnt-track');
    var dots=caro.querySelector('.dnt-dots');
    var slides=track?track.children:[];
    if(!track) return;
    function idx(){
      var c=track.scrollLeft+track.clientWidth/2, best=0, bd=1e9;
      for(var i=0;i<slides.length;i++){
        var s=slides[i], m=s.offsetLeft+s.offsetWidth/2, d=Math.abs(m-c);
        if(d<bd){bd=d;best=i;}
      }
      return best;
    }
    function go(i){
      i=Math.max(0,Math.min(slides.length-1,i));
      var s=slides[i]; if(!s) return;
      track.scrollTo({left:s.offsetLeft-(track.clientWidth-s.offsetWidth)/2,behavior:'smooth'});
    }
    var prev=caro.querySelector('.dnt-arrow.prev'), next=caro.querySelector('.dnt-arrow.next');
    if(prev) prev.addEventListener('click',function(){go(idx()-1);});
    if(next) next.addEventListener('click',function(){go(idx()+1);});
    if(dots){
      dots.innerHTML='';
      for(var i=0;i<slides.length;i++){
        var d=document.createElement('i'); if(i===0)d.className='on';
        d.addEventListener('click',(function(n){return function(){go(n);};})(i));
        dots.appendChild(d);
      }
      var syncing=false;
      track.addEventListener('scroll',function(){
        if(syncing) return; syncing=true;
        requestAnimationFrame(function(){
          var a=idx(),ds=dots.children;
          for(var j=0;j<ds.length;j++) ds[j].className=(j===a?'on':'');
          syncing=false;
        });
      });
    }
  }
  function ready(fn){ if(document.readyState!=='loading')fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    document.querySelectorAll('.dnt-caro').forEach(initCaro);
    /* Reviews load more */
    document.querySelectorAll('[data-dnt-more]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var wrap=document.getElementById(btn.getAttribute('data-dnt-more'));
        if(!wrap) return;
        wrap.querySelectorAll('.dnt-hidden').forEach(function(el){el.classList.remove('dnt-hidden');});
        btn.style.display='none';
      });
    });
  });
})();
